export default function PHP_is_int() {
  return (
    <div>
      <h1>PHP_is_int</h1>
    </div>
  );
}
